import React from 'react';

import { Box } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import ResponsiveLayout from '../components/layout/ResponsiveLayout';
import MissionManagerMap from '../components/MissionPlanner/MissionManagerMap';

const MissionManager: React.FC = () => (
  <ResponsiveLayout>
    <Box className='w-full h-full flex border '>
      <MissionManagerMap />
    </Box>
  </ResponsiveLayout>
);

export default observer(MissionManager);
